import React from "react";
import BackDrop from "./BackDrop";
import { IoWarningOutline } from "react-icons/io5";

const DeleteAlert = ({
  closeHandler,
  resetSelection,
  deleteHandler,
  type,
  count,
  id,
  name,
}) => {
  const handleCancel = () => {
    if (typeof resetSelection === "function") {
      resetSelection();
    }
    closeHandler();
  };
  const handleConfirm = async () => {
    if (id) {
      await deleteHandler(id);
    } else {
      await deleteHandler();
    }
  };

  console.log("DELETE POPUP OPENED:::::")


  return (
    <>
      <div className="fixed left-1/2 top-1/2 z-[2000] w-[98%] max-w-[400px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8 text-center">
        <IoWarningOutline className="mx-auto mt-2 text-center text-[60px] text-pri-clr-orange" />
        <h2 className="mt-2 text-center text-lg font-semibold text-neutral-800">
          Are you sure?
        </h2>
        <p className="mt-2 text-neutral-800">
          Do you really want to delete{" "}
          {type === "multiple"
            ? count > 1
              ? `these ${count} records`
              : `this ${count} record`
            : `this ${name ? name : "record"}`}
          ? This process cannot be undone.
        </p>
        <div className="mt-6 flex w-full justify-center gap-2">
          <div
            className="w-full cursor-pointer max-w-fit rounded bg-pri-clr-blue px-4 py-2 text-sm font-semibold text-white active:scale-95"
            onClick={() => handleCancel()}
          >
            Cancel
          </div>
          <div
            className="w-full cursor-pointer max-w-fit rounded bg-pri-clr-orange px-4 py-2 text-sm font-semibold text-white active:scale-95"
            onClick={() => handleConfirm()}
          >
            Confirm
          </div>
        </div>
      </div>

      <BackDrop className={"z-[100]"} closeHandler={closeHandler} />
    </>
  );
};

export default DeleteAlert;
